export enum AttachmentLevel {
    Analysis = 'ANALYSIS',
    CR13 = 'CR13',
    CR12 = 'CR12',
    CR11 = 'CR11',
    CR10 = 'CR10',
    CR9 = 'CR9',
    CR8 = 'CR8',
    CR7 = 'CR7',
    CR6 = 'CR6',
    CR5 = 'CR5',
    CR4 = 'CR4',
    CR3 = 'CR3',
    CR2 = 'CR2',
    CR1 = 'CR1',
    HAZARD = 'HAZARD',
    OperatingInstruction = 'OPERATING_INSTRUCTION',
    ForceCase = 'FORCE_CASE'
}
